














import { createComponent, inject, provide } from "@vue/composition-api";
import { Zastosowanie } from "@megarax/client/src/resources/plm";
import ZastosowanieSheet from "./ZastosowanieSheet.vue";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";

interface Props {
  value: Zastosowanie[];
  name: string;
}

export default createComponent<Props>({
  components: { ZastosowanieSheet },
  props: {
    value: { required: true, type: Array },
    name: {
      required: true,
      type: String,
    },
  },
  setup(props, ctx) {
    const injectedHighlights: SheetHighlights = inject(sheetOptionsSymbol, {});
    const sheetsHighlights = injectedHighlights[props.name];
    provide(sheetOptionsSymbol, sheetsHighlights);

    return {};
  },
});
